import '@/installCompositionApi.js'
import Vue from 'vue'
import App from '@/App.vue'
import Notifications from 'vue-notification'
import vuetify from '@/plugins/vuetify'
import router from '@/router'
import translate from '@/plugins/translate'
import notify from '@/plugins/notify'
import config from '@/config'
import '@/assets/css/helper-classes.css';
// import LogRocket from 'logrocket';
// LogRocket.init('rp7yli/webbooking');

// Apply runtime branding (window.__APP_CONFIG__.title / .favicon). These used to
// be baked into index.html at build time (VUE_APP_TITLE / VUE_APP_FAVICON); doing
// it here lets the build-once container image set them per instance at runtime.
// Empty config values leave the build-time index.html markup untouched.
if (config.title) {
  document.title = config.title
}
if (config.favicon) {
  let iconLink = document.querySelector("link[rel~='icon']")
  if (!iconLink) {
    iconLink = document.createElement('link')
    iconLink.rel = 'icon'
    document.head.appendChild(iconLink)
  }
  iconLink.href = config.favicon
}

Vue.use(translate)
Vue.config.productionTip = false
Vue.use(Notifications)
Vue.use(notify)

new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
